import { useParams } from 'react-router-dom';
import VendoRForms from '../../../../components/component/Form/VendorFrom';

export default function VendorLogin() {
	const { slug } = useParams();
	localStorage.setItem('slug', slug as string);
	return <VendoRForms slug={slug} />;
}
